import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';

// Reusable official-source link card. Built in Phase A so Phase B data pages
// (Sunshine List breakdown, CAO/management section, City Data expansions)
// drop in cleanly with consistent, source-first presentation.
export const SourceLinkCard = ({ icon: Icon, title, body, url, label }) => (
  <Card className="card-lift" data-testid="source-link-card">
    <CardContent className="p-5 flex flex-col h-full">
      {Icon && (
        <div className="h-10 w-10 rounded-xl bg-[#1a2744] flex items-center justify-center mb-3">
          <Icon className="h-5 w-5 text-[#C9A84C]" />
        </div>
      )}
      <p className="font-serif font-bold text-[#1a2744] leading-snug">{title}</p>
      <p className="text-sm text-slate-600 mt-1.5 leading-relaxed flex-1">{body}</p>
      <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 mt-3 text-sm font-bold text-[#1a2744] underline decoration-[#C9A84C] decoration-2 underline-offset-4" data-testid="source-link">
        {label} <ExternalLink className="h-3.5 w-3.5" />
      </a>
    </CardContent>
  </Card>
);

// Reusable review-status banner for Phase B political interpretation content.
// Any interpretation must show this until Steve approves the wording.
export const DraftReviewBanner = () => (
  <div className="rounded-xl bg-amber-50 border border-amber-300 px-4 py-3" data-testid="draft-review-banner">
    <p className="text-sm font-black uppercase tracking-wider text-amber-900">DRAFT - STEVE REVIEW REQUIRED</p>
    <p className="text-xs text-amber-800 mt-1">This interpretation is a draft and has not been approved for publication.</p>
  </div>
);
